(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTopbarSliders(root) {
      var sliders = (root || document).querySelectorAll('[data-topbar-slider]');
      sliders.forEach(function (slider) {
        if (slider.dataset.sliderInitialized) return;
        slider.dataset.sliderInitialized = 'true';

        var track = slider.querySelector('[data-slider-track]');
        var originalSlides = Array.prototype.slice.call(track.children);
        if (originalSlides.length < 2) return;

        // Clone the first slide and append it at the end so the loop feels seamless
        var firstClone = originalSlides[0].cloneNode(true);
        firstClone.setAttribute('aria-hidden', 'true');
        track.appendChild(firstClone);

        var total = originalSlides.length;
        var autoplay = slider.dataset.autoplay === 'true';
        var speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var current = 0;
        var timer = null;
        var transitioning = false;

        function setPosition(index, animate) {
          track.style.transition = animate ? 'transform 0.5s ease' : 'none';
          track.style.transform = 'translateX(-' + (index * 100) + '%)';
        }

        setPosition(0, false);

        function next() {
          if (transitioning) return;
          transitioning = true;
          current += 1;
          setPosition(current, true);
        }

        track.addEventListener('transitionend', function () {
          transitioning = false;
          if (current === total) {
            current = 0;
            setPosition(current, false);
          }
        });

        function start() {
          if (!autoplay || prefersReducedMotion) return;
          stop();
          timer = setInterval(next, speed);
        }

        function stop() {
          if (timer) clearInterval(timer);
        }

        start();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initTopbarSliders(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initTopbarSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
